import { createBrowserHistory } from 'history';
export const BLOCK_SILENT = '__anchor_block_silent__';
let confirmHandler = null;
export const setNavigationConfirmHandler = (handler)=>{
    confirmHandler = handler;
};
export const navigationGetUserConfirmation = (message, callback)=>{
    if (message === BLOCK_SILENT) {
        callback(false);
        return;
    }
    if (confirmHandler) {
        confirmHandler(message).then(callback);
        return;
    }
    callback(true);
};
const browserHistory = createBrowserHistory({
    getUserConfirmation: navigationGetUserConfirmation
});
// WHY: bridge history@4 to the v5+ shape v6 HistoryRouter needs (createURL/encodeLocation + a `listen` emitting one `{action, location}` update, not history@4's two args) — else setState gets a bad shape and the Router reads `pathname` of undefined at boot.
const toHref = (to)=>typeof to === 'string' ? to : browserHistory.createHref(to);
const rawListen = browserHistory.listen.bind(browserHistory);
Object.assign(browserHistory, {
    listen: (listener)=>rawListen((location, action)=>listener({
                action,
                location
            })),
    createURL: (to)=>new URL(toHref(to), window.location.origin),
    encodeLocation: (to)=>{
        const url = new URL(toHref(to), window.location.origin);
        return {
            pathname: url.pathname,
            search: url.search,
            hash: url.hash
        };
    }
});
export const history = browserHistory;
// WHY: consumers written for history@4 (Sentry's router tracing) need the unbridged `listen`, else every navigation reaches them with an undefined action and is dropped.
export const history4View = {
    get location () {
        return browserHistory.location;
    },
    listen: rawListen
};
